import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {AgentsProfileHiperioService} from "../../../shared/services/agents-profile-hiperio.service";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {Ofwca} from "../../../shared/interface/ofwca";
import {REGISTRATION_STATUS_REGISTERED} from "../../../shared/services/dict.service";


export interface ChangeRegistrationDialogData {
  partnerId: string;
  ofwca: Ofwca;
  insuranceCompany: InsuranceCompany;
  hiperioRegistrationConfigId: string;
}

@Component({
  selector: 'app-change-registration-dialog',
  templateUrl: './change-registration-hiperio-dialog.component.html',
  styleUrls: ['./change-registration-hiperio-dialog.component.scss']
})
export class ChangeRegistrationHiperioDialogComponent implements OnInit, OnDestroy {

  changeRegistrationForm: FormGroup;
  partnerId: string;
  ofwca: Ofwca;
  insuranceCompany: InsuranceCompany;
  hiperioRegistrationConfigId: string;
  processingRequest = false;
  enableSaveButton = false;
  registrationControl: FormControl;
  readonly REGISTRATION_STATUS_REGISTERED = REGISTRATION_STATUS_REGISTERED;



  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    public dialogRef: MatDialogRef<ChangeRegistrationHiperioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRegistrationDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private agentsProfileHiperioService: AgentsProfileHiperioService,
    private snack: MatSnackBar,
  ) {
    this.partnerId = data.partnerId;
    this.ofwca = data.ofwca;
    this.insuranceCompany = data.insuranceCompany;
    this.hiperioRegistrationConfigId = data.hiperioRegistrationConfigId;
    this.changeRegistrationForm = fb.group({
      registration: this.registrationControl = fb.control('',
        [Validators.required]),
    });
  }


  ngOnInit(): void {
    this.changeRegistrationForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeRegistrationForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    this.processingRequest = true;

    this.agentsProfileHiperioService.sendUpdateRegistration(this.changeRegistrationForm.value, this.hiperioRegistrationConfigId)
      .subscribe(() => {
        this.snack.open('Pomyślnie zmieniono rejestracjie', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji salda wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
}
